import featureFlagService from '@/api/featureflag'
import { FEATURE_FLAG } from '../types'

export default {
  namespaced: true,
  state: {
    featureFlags: [],
    featureFlagWithClients: {
      id: null,
      name: '',
      start: null,
      isEnabledForAllClients: false,
      clients: []
    },
    availableClients: []
  },
  getters: {
    featureFlags: (state) => {
      return state.featureFlags
    }
  },
  mutations: {
    [FEATURE_FLAG.SET_FEATURE_FLAGS](state, featuresFlags) {
      state.featureFlags = featuresFlags
    },
    [FEATURE_FLAG.SET_FEATURE_FLAG](state, featureFlagWithClients) {
      state.featureFlagWithClients = featureFlagWithClients
    }
  },
  actions: {
    getFeatureFlags: function ({ dispatch, commit }) {
      dispatch('Global/showLoading', null, { root: true })
      return new Promise((resolve, reject) => {
        featureFlagService.getFeatureFlags().then((response) => {
          resolve()
          commit(FEATURE_FLAG.SET_FEATURE_FLAGS, response.data)
        }).catch((error) => {
          reject(error)
        }).finally(() => {
          dispatch('Global/hideLoading', null, {root: true})
        })
      })
    },
    getFeatureFlag: function({ dispatch }, featureId) {
      dispatch('Global/showLoading', null, { root: true })
      return new Promise((resolve, reject) => {
        featureFlagService.getFeatureFlag(featureId).then((response) => {
          dispatch('setFeatureFlagWithClients', response.data)
          resolve(response.data)
        }).catch((error) => {
          reject(error)
        }).finally(() => {
          dispatch('Global/hideLoading', null, { root: true })
        })
      })
    },
    deleteFeatureFlag: function ({ dispatch }, featureId) {
      dispatch('Global/showLoading', null, { root: true })
      return new Promise((resolve, reject) => {
        featureFlagService.deleteFeatureFlag(featureId).then(() => {
          resolve()
          dispatch('FeatureFlag/getFeatureFlags', null, { root: true })
        }).catch((error) => {
          reject(error)
        }).finally(() => {
          dispatch('Global/hideLoading', null, {root: true})
        })
      })
    },
    activateFeatureFlag: function(_, featureId){
      return new Promise((resolve, reject) => {
        featureFlagService.activateFeatureFlag(featureId).then(() => {
          resolve()
        }).catch((error) => {
          reject(error)
        })
      })
    },
    deactivateFeatureFlag: function(_, featureId){
      return new Promise((resolve, reject) => {
        featureFlagService.deactivateFeatureFlag(featureId).then(() => {
          resolve()
        }).catch((error) => {
          reject(error)
        })
      })
    },
    createFeatureFlag: function({dispatch}, body) {
      dispatch('Global/showLoading', null, { root: true })
      return new Promise((resolve, reject) => {
        featureFlagService.createFeatureFlag(body).then(() => {
          resolve()
        }).catch((error) => {
          reject(error)
        }).finally(() => {
          dispatch('Global/hideLoading', null, {root: true})
        })
      })
    },
    updateFeatureFlag: function({dispatch}, body) {
      dispatch('Global/showLoading', null, { root: true })
      return new Promise((resolve, reject) => {
        featureFlagService.updateFeatureFlag(body).then(() => {
          resolve()
        }).catch((error) => {
          reject(error)
        }).finally(() => {
          dispatch('Global/hideLoading', null, {root: true})
        })
      })
    },
    setFeatureFlagWithClients({commit}, featureFlag) {
      commit(FEATURE_FLAG.SET_FEATURE_FLAG, featureFlag)
    }
  }
}
